import script from "./ChSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ChSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ChSwitch.vue?vue&type=style&index=0&id=433a144c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433a144c"]])

export default __exports__